import { PartnerTypeEnumLabels } from "@boundless/bl-api-client/customer/models/PartnerTypeEnumLabels"

import { PerkCard } from "@/components/perks/PerkCard"

import type {
  PartnerTypeEnum,
  Perk,
} from "@boundless/bl-api-client/customer/models"

export function PartnerTypeSection({
  type,
  perks,
}: {
  type: PartnerTypeEnum
  perks: Perk[]
}) {
  const filteredPerks = perks.filter((p) => p.partnerType == type)
  if (!filteredPerks.length) {
    return null
  }

  return (
    <div className="flex flex-col gap-5">
      <h1 className="text-md font-bold">{PartnerTypeEnumLabels[type]}</h1>
      <div className="flex flex-wrap gap-6">
        {filteredPerks.map((perk) => (
          <PerkCard key={perk.slug} perk={perk} />
        ))}
      </div>
    </div>
  )
}
